export default __webpack_public_path__ + "static/media/litho-demo-blog-post-layout-05.a9421255.jpg";